import {Box, BoxProps} from "@mantine/core";
import {Feature, useFeature} from "./featureFlags";

type FeatureGateProps = BoxProps & {
    feature: Feature;
    children: React.ReactNode;
};

/**
 * Render gate: children mount only when the feature is confirmed enabled
 * (role AND flag) — nothing renders while user state resolves. When
 * DebugIndicators is on, gated content is wrapped in a dashed outline.
 */
export const FeatureGate = ({
    feature,
    children,
    style,
    ...boxProps
}: FeatureGateProps) => {
    const {enabled} = useFeature(feature);
    const {enabled: showDebugIndicators} = useFeature(
        Feature.DebugIndicators
    );

    if (!enabled) {
        return null;
    }

    if (showDebugIndicators) {
        return (
            <Box
                style={{
                    outline: "2px dashed var(--mantine-color-grape-5)",
                    outlineOffset: "2px",
                    ...style,
                }}
                {...boxProps}
            >
                {children}
            </Box>
        );
    }

    return children;
};
